var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25869 1.63039C7.25869 1.28224 7.55251 1 7.91494 1H12.0852C12.4476 1 12.7414 1.28224 12.7414 1.63039C12.7414 1.97855 12.4476 2.26078 12.0852 2.26078H7.91494C7.55251 2.26078 7.25869 1.97855 7.25869 1.63039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16319 3.65207H15.8368C16.4792 3.65207 17 4.15025 17 4.76479C17 5.37933 16.4792 5.87751 15.8368 5.87751H4.16319C3.52078 5.87751 3 5.37933 3 4.76479C3 4.15025 3.52078 3.65207 4.16319 3.65207Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3337 4.29088C15.6961 4.29088 15.9899 4.57311 15.9899 4.92127V16.21C15.9899 17.6238 14.9809 19 13.4883 19H6.6353C5.14266 19 4.13365 17.6238 4.13365 16.21V8.19003C4.13365 7.84187 4.42747 7.55964 4.7899 7.55964C5.15234 7.55964 5.44615 7.84187 5.44615 8.19003V16.21C5.44615 17.1717 6.098 17.7392 6.6353 17.7392H13.4883C14.0256 17.7392 14.6774 17.1717 14.6774 16.21V4.92127C14.6774 4.57311 14.9713 4.29088 15.3337 4.29088Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64472 8.39868C9.00716 8.39868 9.30097 8.68092 9.30097 9.02907V15.8678C9.30097 16.2159 9.00716 16.4982 8.64472 16.4982C8.28228 16.4982 7.98847 16.2159 7.98847 15.8678V9.02907C7.98847 8.68092 8.28228 8.39868 8.64472 8.39868Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3555 8.39868C11.718 8.39868 12.0118 8.68092 12.0118 9.02907V15.8678C12.0118 16.2159 11.718 16.4982 11.3555 16.4982C10.9931 16.4982 10.6993 16.2159 10.6993 15.8678V9.02907C10.6993 8.68092 10.9931 8.39868 11.3555 8.39868Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.cce8d45b8b53ce287d91838188095d24.svg";
export { ForwardRef as ReactComponent };